import React from "react";
import { useTheme } from "../../contexts/ThemeContext";
import { useLocalization } from "../../contexts/LocalizationContext";
import { useIsMobile, useDeviceType } from "../../App";

const Header = ({ title, rightComponent, leftComponent }) => {
  const { theme } = useTheme();
  const isMobile = useIsMobile();
  const deviceType = useDeviceType();

  const headerStyles = {
    height: deviceType === 'desktop' ? 81 : deviceType === 'tablet' ? 64 : 56,
    display: "flex",
    alignItems: "center",
    // justifyContent: "space-between",
    padding: deviceType === 'desktop' ? "0 16px" : deviceType === 'tablet' ? "0 12px" : "0 8px",
    gap: deviceType === 'tablet' ? 16 : 12,
    backgroundColor: theme.surface,
    borderBottom: `1px solid ${theme.border}`,
    boxShadow: `0 2px 8px ${theme.shadow}`,
    position: "sticky",
    top: 0,
    zIndex: 100,
  };

  const settingsTitles = [
    "Settings", // English
    "Налаштування", // Ukrainian
    "Ustawienia", // Polish
    "Настройки", // Russian
  ];

  const titleStyles = {
    fontSize: deviceType === 'desktop' ? "1.5rem" : deviceType === 'tablet' ? "1.2rem" : "0.9rem",
    fontWeight: deviceType === 'desktop' ? 600 : deviceType === 'tablet' ? 500 : 400,
    color: theme.text,
    paddingTop: deviceType === 'desktop' ? "15px" : deviceType === 'tablet' ? "10px" : "7px",
    paddingRight: deviceType === 'desktop' ? "20px" : deviceType === 'tablet' ? "15px" : "10px",
    paddingBottom: deviceType === 'desktop' ? "20px" : deviceType === 'tablet' ? "15px" : "10px",
    marginRight: "auto",
    whiteSpace: deviceType !== 'desktop' && "nowrap",
    overflow: deviceType !== 'desktop' && "hidden",
    textOverflow: deviceType !== 'desktop' && "ellipsis",
  };

  const sideComponentStyles = {
    display: "flex",
    alignItems: "center",
    minWidth: deviceType === 'desktop' ? "40px" : deviceType === 'tablet' ? "36px" : "28px",
    // marginRight: isMobile ? 4 : 8, // add a little space between hamburger and title
  };

  return (
    <header style={headerStyles}>
      <div style={sideComponentStyles}>{leftComponent}</div>
      <h1 style={titleStyles}>{title}</h1>
      <div style={sideComponentStyles}>{rightComponent}</div>
    </header>
  );
};

export default Header;
